@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.inline {
  display: flex;
  .icon-wrapper {
    .icon {
      margin-top: 10px;
      margin-left: 5px;
      cursor: pointer;
      color: @local-delivery--driver-tip--text-color;
      height: 16px;
      width: auto;
    }
  }

  .csw-input-short {
    height: 34px;
    width: 154px;
  }
}
